<script>
   /*************************************************************/
   /* DatasetWidget                                             */
   /* -------------------------                                 */
   /* widget to show information about loaded dataset           */
   /*************************************************************/

   import Container from '../controls/Container.svelte';
   import ButtonCancel from '../controls/ButtonCancel.svelte';

   // calibration set
   export let dataset;

</script>

{#if dataset }
   <!-- dataset is loaded - show info and cancel button -->
   <Container>
      <p class="dataset-info">
         <span>Data file:</span> <span title="{dataset.fileName}" class="file-name">{dataset.fileName}</span><br>
         <span>Size:</span> <span class="file-size">{dataset.values.nrows} &times; {dataset.values.ncols}</span>
      </p>
      <ButtonCancel on:click />
   </Container>
{/if}

<style>

   .dataset-info {
      line-height: 1.5em;
   }
   .dataset-info > :global(span) {
      vertical-align: middle;
      color: #a0a0a0;
   }

   .dataset-info > .file-name,
   .dataset-info > .file-size {
      display: inline-block;
      padding: 0;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 25ch;
      color: #222;
   }
</style>